import { render, staticRenderFns } from "./JobRoleSearch.vue?vue&type=template&id=65f50a3c&scoped=true&lang=pug"
import script from "./JobRoleSearch.vue?vue&type=script&lang=ts"
export * from "./JobRoleSearch.vue?vue&type=script&lang=ts"
import style0 from "./JobRoleSearch.vue?vue&type=style&index=0&id=65f50a3c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f50a3c",
  null
  
)

export default component.exports